import React from 'react';

import i18n from 'i18n-js';
import * as yup from 'yup';
import { Button } from '@material-ui/core';
import { Formik, Form } from 'formik';

import { Input } from 'components/shared';
import styles from '../styles';

interface PriceOptionFormProps {
    name?: string;
    action: (name: string) => void;
    cancel: () => void;
}

export function PriceOptionForm(props: PriceOptionFormProps) {
    const classes = styles();
    const initialValues = {
        name: props.name || '',
    };
    const validationSchema = yup.object().shape({
        name: yup.string().required(
            i18n.t('form.errors.required', {
                name: 'Name',
            })
        ),
    });
    return (
        <div className={classes.priceItemContainerEdit}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => props.action(values.name)}
            >
                {({ errors }) => (
                    <Form>
                        <>
                            <Input
                                size="small"
                                error={errors.name}
                                variant="outlined"
                                fullWidth={true}
                                name={`name`}
                                type="text"
                                label={i18n.t('form.name')}
                                placeholder={i18n.t('form.name')}
                            />
                        </>
                        {
                            <div>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={props.cancel}
                                    style={{ marginRight: 10, marginLeft: 15 }}
                                >
                                    {i18n.t('button.cancel')}
                                </Button>
                                <Button type="submit" variant="contained" color="primary">
                                    {i18n.t('common.save')}
                                </Button>
                            </div>
                        }
                    </Form>
                )}
            </Formik>
        </div>
    );
}
